<!-- <p-dropdown
  #dropdown
  [options]="value"
  [(ngModel)]="selectedValue"
  [optionLabel]="optionLabel"
  [showClear]="true"
>
</p-dropdown> -->

<ng-content></ng-content>

<div class="ion-action-sheet" *ngIf="dialogState != null">
  <div
    [@backdropFade]="dialogState"
    (@backdropFade.done)="endState($event)"
    class="backdrop"
    #backdrop
    (click)="close()"
  ></div>
  <div tabindex="0" class="sc-ion-action-sheet-md"></div>
  <div
    #dialog
    [@dialogOpen]="dialogState"
    class="action-sheet-wrapper ion-overlay-wrapper sc-ion-action-sheet-md"
    role="dialog"
  >
    <div class="action-sheet-container sc-ion-action-sheet-md">
      <div class="action-sheet-group sc-ion-action-sheet-md">
        <button
          type="button"
          class="action-sheet-button ion-activatable ion-focusable action-sheet-selected select-interface-option md sc-ion-action-sheet-md"
        >
          <span class="action-sheet-button-inner sc-ion-action-sheet-md">{{
            headerText
          }}</span>
        </button>
        <button
          *ngFor="let rowData of value; let i = index"
          type="button"
          (click)="selectValue(rowData, $event)"
          class="action-sheet-button ion-activatable ion-focusable action-sheet- select-interface-option md sc-ion-action-sheet-md"
        >
          <span class="action-sheet-button-inner sc-ion-action-sheet-md">{{
            rowData | displayValue
          }}</span>
        </button>

        <!-- <button
          type="button"
          class="action-sheet-button ion-activatable ion-focusable action-sheet- select-interface-option md sc-ion-action-sheet-md"
        >
          <span class="action-sheet-button-inner sc-ion-action-sheet-md"
            >Mute for a week</span
          ></button
        ><button
          type="button"
          class="action-sheet-button ion-activatable ion-focusable action-sheet- select-interface-option md sc-ion-action-sheet-md"
        >
          <span class="action-sheet-button-inner sc-ion-action-sheet-md"
            >Mute for a year</span
          >
        </button>
         -->
      </div>
      <div
        class="action-sheet-group action-sheet-group-cancel sc-ion-action-sheet-md"
      >
        <button
          type="button"
          (click)="close()"
          class="action-sheet-button ion-activatable ion-focusable action-sheet-cancel sc-ion-action-sheet-md"
        >
          <span class="action-sheet-button-inner sc-ion-action-sheet-md">{{
            cancelText
          }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
